import { Component, OnInit, Input } from '@angular/core';
import { InvoiceLineItem } from 'src/app/model/invoice.model';

@Component({
  selector: 'app-invoice-line-item',
  templateUrl: './invoice-line-item.component.html',
  styleUrls: ['./invoice-line-item.component.scss']
})
export class InvoiceLineItemComponent implements OnInit {
  @Input() lineItem: InvoiceLineItem;

  public unitPrice: string = "";
  public totalPrice: string = "";

  constructor() {

  }

  private formatPrice(price: number): string {
    return price < 0 ? `(${price * -1})` : price.toString();
  }

  ngOnInit(): void {
    this.unitPrice = this.formatPrice(this.lineItem.unitPrice);
    this.totalPrice = this.formatPrice(this.lineItem.totalPrice);
  }

}
